
export const PieChartOptions = {
  x: 0.25, y: 1, w: 9.5, h: 4.0,
  showLegend: true, legendPos: 'r', legendFontSize: 15, legendFontFace: 'Calibri',
  dataLabelPosition:'outEnd',
  showPercent: true,
  showLeaderLines: true,
  dataBorder: { pt: '1', color: 'F1F1F1' },
  dataLabelFontBold: true, dataLabelColor: '000000',
  chartColors: ['FC0000', 'FFCC00', '009900', '0088CC', '696969', '6600CC', "FF8000", "FFFF00", "80FF00", "FF00FF", "00FFFF", "00FF00", 'dc0ee0', '00B050', 'dd3513', '81e00e', 'e0c10f', '0ee0a4', '2de00e', '0e8fe0', '9a0ee0', '7030A0', '000000', '42f4a7', 'e00e62']
};

export const MSDoughnutChartOptions = {
  x: 0, y: 0.3, w: 2.5, h: 2.5,
  showLegend: false,
  showPercent: true,
  dataLabelFontSize: 10,
  showLabel: false,
  showValue: false,
  showTitle: false,
  holeSize: 55,
  layout: { x: 0.075, y: 0.075, w: 0.85, h: 0.85 },
  dataLabelFontBold: true, dataLabelColor: '000000',
  chartColors: []
};

  export const StackedBarChartOptions = {
    x: 0.25, y: 1, w: 9.5, h: 4.0,
    barDir: 'col',
    showLabel: true, showPercent: true,
    barGrouping: 'percentStacked', chartColors: [],
    catAxisLabelFontFace: 'Calibri', catAxisLabelFontSize: 11, catAxisLabelFontBold: true,
    valAxisLabelFontFace: 'Calibri', valAxisLabelFontSize: 11,
    catAxisLabelRotate: 0, 
    dataLabelFontFace: 'Calibri', dataLabelFontSize: 12, dataLabelFontBold: true,  dataLabelFormatCode: '#\%;;;',    
    barGapWidthPct: 150,
    showValue: true, valGridLine: 'none',
    valAxisLabelFormatCode: '0%'
};
  



export const PieChartOptionsNew = {
  x: 0.25, y: 1, w: 9.5, h: 4.0,
  showLegend: true,
  legendPos: 'r',
  legendFontSize: 15,
  legendFontFace: 'Poppins',
  dataLabelFontFace: 'Poppins Medium', 
  dataLabelPosition: 'outEnd',
  showPercent: true,
  dataLabelFontSize: 14,
  dataLabelFontBold: true,
  dataLabelColor: '333333',
  dataBorder: { pt: '1', color: 'F1F1F1' },
  chartColors: ['c00000', 'ff3300', 'f48322', 'f9b407', '73c03c', '06a841', '1eb8b3', '0070c0', '1f4e79', '4f0a94', '9954cc', 'b22d6e']
};

export const DoughnutChartOptionsNew = {
  x: 0.25, y: 0.8, w: 9.5, h: 4.7,
  showLegend: true,
  legendPos: 'r',
  legendFontSize: 15,
  legendFontFace: 'Poppins',
  dataLabelFontFace: 'Poppins Medium', 
  dataLabelPosition: 'outEnd',
  showPercent: true,
  dataLabelFontSize: 14,
  dataLabelFontBold: true,
  dataLabelColor: 'FFFFFF',
  holeSize: 60,
  chartColors: ['c00000','ff3300','f48322','f9b407','73c03c','06a841','1eb8b3','0070c0','1f4e79','4f0a94','9954cc','b22d6e']};

export const MSDoughnutChartOptionsNew = {
  x: 0.2, y: 1, w: 2, h: 2,
  showLegend: false,
  showPercent: true,
  dataLabelFontSize: 10,
  legendFontFace: 'Poppins',
  showLabel: false,
  showValue: false,
  showTitle: false,
  holeSize: 55,
  layout: { x: 0.075, y: 0.075, w: 0.85, h: 0.85 },
  dataLabelFontBold: true, dataLabelColor: 'FFFFFF', dataLabelFontFace: 'Poppins',
  chartColors: []
};

export const StackedVerticalBarChartOptionsNew = {
  x: 0.25, y: 1, w: 9.5, h: 4.4,
  barDir: 'col',
  showLabel: true, showPercent: true,
  barGrouping: 'percentStacked', chartColors: [],
  catAxisLabelFontFace: 'Poppins', catAxisLabelFontSize: 10, catAxisLabelColor: '595959', catAxisTitleColor: '595959', catAxisLabelRotate: 0,
  valAxisLabelFontFace: 'Poppins', valAxisLabelFontSize: 10, valAxisLabelColor: '595959', valAxisTitleColor: '595959', valAxisLineShow: false,
  dataLabelFontFace: 'Poppins', dataLabelFontSize: 10, dataLabelColor: 'FFFFFF', dataLabelFormatCode: '#\%;;;',
  barGapWidthPct: 100,
  showValue: true, valGridLine: {style:'none'},
  valAxisLabelFormatCode: '0%',
};

export const StackedHorizontalBarChartOptionsNew = {
  x: 0.25, y: 1, w: 9.5, h: 4.0,
  barDir: 'bar',
  showLabel: true, showPercent: true,
  barGrouping: 'percentStacked', chartColors: [],
  axisLineColor:'FFFFFF',
  catAxisLabelFontFace: 'Poppins', catAxisLabelFontSize: 9, catAxisLabelColor: '595959', catAxisTitleColor: '595959', catAxisLabelRotate: 0, catAxisLineShow: false,
  valAxisHidden: true,
  valAxisLabelFontFace: 'Poppins', valAxisLabelFontSize: 10, valAxisLabelColor: '595959', valAxisTitleColor:'595959',
  dataLabelFontFace: 'Poppins', dataLabelFontSize: 10, dataLabelColor: '333333',
  barGapWidthPct: 100,
  dataLabelFormatCode: '#\%;;;',
  showValue: true, valGridLine: { style:'none'},
  valAxisLabelFormatCode: '0%',
  layout: { x: 0.3, y: 0, w: 0.7, h: 1}
}

export const BarChartOptionsNew = {
  x: 0.25, y: 1, w: 7, h: 4.0,
  showPercent: true,
  axisLineColor: 'FFFFFF',
  catAxisLabelColor: '808080',
  valAxisLabelColor:'808080',
  showLabel: true, 
  showValue: true, valGridLine: { style: 'none' },
  dataLabelFontFace: 'Poppins', dataLabelFontSize: 14, dataLabelColor: 'FFFFFF', bold: true,
  chartColors: ['f58026', 'f58026', 'f58026'],
  catGridLine: { style: 'none' },
  valAxisLineShow: false,
}
export const EngagementWiseSplitChartOptions = {
  x: 0.2,
  y: 0.8,
  w: 2.25,
  h: 4,
  barDir: "bar",

  catAxisLabelFontFace: 'Poppins',
  catAxisLabelFontSize: 9,

  valAxisLineShow: false,
  valAxisHidden: true,
  
  showValue: true,
  dataLabelPosition: "outEnd",
  dataLabelFormatCode: "#%",
  chartColors: ["f58026"],
  showTitle: true,
  valGridLine: { style: 'none' },
  titleFontSize: 10,
  titleFontFace: 'Poppins',
  titleColor: "000000",
  title: '',
}